/* eslint-disable @typescript-eslint/no-explicit-any */
export const API_BASE_URL: string =
  (import.meta as any).env?.VITE_HOST_API ?? 'https://api.drivys.com/api/'

// v2 APIs (Fiber) are now served on the SAME origin/port as v1 — the server
// routes /api/v2/* to Fiber and everything else to Gin on the one port. So v2
// uses the same base as v1 by default. VITE_API_V2_BASE_URL can still override
// it (e.g. to hit the raw Fiber :8081 listener directly).
export const API_V2_BASE_URL: string =
  (import.meta as any).env?.VITE_API_V2_BASE_URL ?? API_BASE_URL

// GraphQL lives on the same host as the REST API, so derive it from VITE_HOST_API
// (…/api/ -> …/graphql). VITE_GRAPHQL_URL can still override it.
export const GRAPHQL_URL: string =
  (import.meta as any).env?.VITE_GRAPHQL_URL ??
  API_BASE_URL.replace(/\/api\/?$/, '/graphql')

export const APP_ENV: string =
  (import.meta as any).env?.MODE ?? 'development'

// Google Maps key for the dashboard Heat Map (trainers/students).
// Accepts either VITE_APP_GOOGLE_API_KEY (old project) or VITE_GOOGLE_MAPS_API_KEY.
export const GOOGLE_MAPS_API_KEY: string =
  (import.meta as any).env?.VITE_APP_GOOGLE_API_KEY ??
  (import.meta as any).env?.VITE_GOOGLE_MAPS_API_KEY ?? ''

export const PAGE_SIZE = 15

// Maps the numeric payment-method enum returned by the API
// (public/enum/get-payment-method-type-enum) to a human-readable label.
export const PAYMENT_METHOD_LABELS: Record<number, string> = {
  0: 'Cash',
  1: 'Card',
  2: 'Apple Pay',
  3: 'Wallet',
  4: 'Google Pay',
  5: 'External',
  6: 'Samsung Pay',
  7: 'Tabby',
}

export function getPaymentMethodLabel(value: unknown): string {
  if (value === null || value === undefined || value === '') return 'Unknown'
  const num = Number(value)
  if (!Number.isNaN(num) && PAYMENT_METHOD_LABELS[num]) return PAYMENT_METHOD_LABELS[num]
  return String(value)
}

// Status accent colors, per design spec — applied everywhere StatusBadge is
// used across the dashboard (bookings, sessions, certificates, refunds, todo…).
const STATUS_PENDING     = 'bg-[var(--Accents-Orange)] text-white border border-transparent'
const STATUS_CONFIRMED   = 'bg-[var(--Accents-Blue)] text-white border border-transparent'
const STATUS_IN_PROGRESS = 'bg-[var(--Accents-Cyan)] text-white border border-transparent'
const STATUS_COMPLETED   = 'bg-[var(--Accents-Green)] text-white border border-transparent'
const STATUS_CANCELLED   = 'bg-[var(--Accents-Red)] text-white border border-transparent'

export const STATUS_BADGE_STYLES: Record<string, string> = {
  pending:        STATUS_PENDING,
  confirmed:      STATUS_CONFIRMED,
  completed:      STATUS_COMPLETED,
  cancelled:      STATUS_CANCELLED,
  refunded:       'bg-purple-50 text-purple-800 border border-purple-200',
  active:         'bg-green-50 text-green-800 border border-green-200',
  inactive:       'bg-red-50 text-red-800 border border-red-200',
  approved:       'bg-green-50 text-green-800 border border-green-200',
  rejected:       STATUS_CANCELLED,
  paid:           'bg-green-50 text-green-800 border border-green-200',
  open:           STATUS_IN_PROGRESS,
  'in-progress':  STATUS_IN_PROGRESS,
  inprogress:     STATUS_IN_PROGRESS,
  closed:         'bg-gray-100 text-gray-600 border border-gray-200',
  true:           'bg-green-50 text-green-800 border border-green-200',
  false:          'bg-red-50 text-red-800 border border-red-200',
}
